import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHttp from 'services/axiosHttp';
import dayjs from 'dayjs';

export const fetchQrScannedEmpSummaryList = createAsyncThunk(
  'qrScannedEmpSummaryList/fetchQrScannedEmpSummaryList',
  async (filters = {}, { rejectWithValue }) => {
    try {
      const params = {
        department: filters.department || undefined,
        qr_type: filters.qr_type || undefined,
        date_start: filters.date ? dayjs(filters.date).format('YYYY-MM-DD') : undefined,
        date_end: filters.date ? dayjs(filters.date).format('YYYY-MM-DD') : undefined
      };
      
      const response = await axiosHttp.get('lcqr/getcanlogs', { params });
      
      if (response.data && response.data.success) {
        return response.data.data || [];
      } else {
        return rejectWithValue(response.data?.message || 'Failed to fetch Employee Summary');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const qrScannedEmpSummaryListSlice = createSlice({
  name: 'QrScannedEmpSummaryListSlice',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQrScannedEmpSummaryList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
        state.data = [];
      })
      .addCase(fetchQrScannedEmpSummaryList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchQrScannedEmpSummaryList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default qrScannedEmpSummaryListSlice.reducer;
